import { memo, useMemo } from "react"
import { styled } from "@mui/material"
import AmountInfo from "../AmountInfo"
import { AmountField, AmountFieldProps } from "../../../../../muiStyled/Inputs/textfield"
import { useBasketAmountFieldLogic } from "./useBasketAmountFieldLogic"

type BasketAmountFieldProps = {
    originalQuantity: number
    division: number
    onChangeQuantity?: (value: number, loadErpInfo: boolean) => void
    hasSuggestedQuantity?: boolean
    disabled?: boolean
    loadErpInfos?: boolean
    showQuantityWithDecimals?: boolean
    compactView?: boolean
}

type AmountFieldType = AmountFieldProps & { compactView?: boolean }

const StyledAmountField = styled(AmountField)(({ compactView }: AmountFieldType) => ({
    marginTop: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    ".MuiInputBase-formControl": { paddingRight: 4 },
    ".MuiInputAdornment-positionEnd": { marginLeft: 0 },
    ".MuiInputBase-input": {
        boxSizing: "border-box",
        height: 30,
        padding: 8,
        paddingRight: 4,
        width: 64,
    },
    "&[data-has-amountinfo] .MuiInputBase-input": {
        paddingRight: 0,
        width: 40,
    },
    ...(compactView && {
        ".MuiInputBase-input": {
            width: 32,
        },
    }),
}))

export const BasketAmountField = memo((props: BasketAmountFieldProps) => {
    const { division, originalQuantity, onChangeQuantity, hasSuggestedQuantity, disabled, showQuantityWithDecimals, compactView } = props

    const { quantity, setQuantity, inputRef, handleBlur, handleFocus, handleKeyUp, maxAmountValue, amountInfo } = useBasketAmountFieldLogic({
        division,
        originalQuantity,
        onChangeQuantity,
        hasSuggestedQuantity,
        showQuantityWithDecimals,
    })

    const renderAmountInfo = useMemo(() => (amountInfo ? <AmountInfo text={amountInfo} /> : null), [amountInfo])

    return (
        <StyledAmountField
            {...(amountInfo && { "data-has-amountinfo": 1 })}
            className="basketAmountField"
            inputRef={inputRef}
            min={division}
            max={maxAmountValue}
            step={division}
            InputProps={{
                endAdornment: renderAmountInfo,
            }}
            value={quantity}
            disabled={disabled}
            onChange={(value) => setQuantity(value)}
            onKeyUp={handleKeyUp}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onClick={() => inputRef?.current?.focus()} // fix firefox not running into onBlur - NEXT-28029
        />
    )
})
